import { ELEM_TYPES } from './constants/ElementTypes'
import _ from 'lodash'
import { getElementDataRoot } from '../constants/getElementDataRoot'
import { detectIsTargetKeyInRepeatEl } from './StateUtils'
import { Map } from 'immutable'

const getKeyPathFromUID = (uidKey) => {
  const keyString = String(_.last(String(uidKey).split('#-#')))
  return keyString.split(':')
}

const adjustKeyPathIfRepeat = (keyPath, isBtnRepeat, index, retState) => {
  if (!isBtnRepeat || _.isNil(index)) return keyPath

  const isRepeatContainer = detectIsTargetKeyInRepeatEl(keyPath, retState)
  if (!isRepeatContainer) return keyPath

  const [section, , id] = keyPath
  const elemRootKey = ['Header', 'Footer'].includes(section) ? 'project' : retState.get('page')
  const elem = retState.getIn([...getElementDataRoot(elemRootKey), 'elements', id], new Map())

  if (
    elem.get('type') === ELEM_TYPES.FORM_FIELD &&
    [ELEM_TYPES.DATE_RANGE, ELEM_TYPES.RADIO, ELEM_TYPES.LOOKUP].includes(elem.getIn(['props', 'control']))
  ) {
    // Insert index before the last key
    const newPath = [...keyPath]
    newPath.splice(keyPath.length - 1, 0, index)
    return newPath
  } else {
    return [...keyPath, index]
  }
}

/**
 * Evaluate a custom expression for Affect Elements "Set Custom Value"
 * by replacing placeholders with values from the provided parameters and portal state.
 * @param action Affect Elements action data
 * @param params app params
 * @param portalState app state
 * @param isBtnRepeat
 * @param retState - the state object to update
 * @param index - index of the repeat container (null if not inside a repeat container)
 * @returns the evaluated expression with the placeholders replaced with actual values
 */
export const evaluateCustomExpression = (action, params, portalState, isBtnRepeat, retState, index) => {
  let expression = action.get('expression_text', '')
  let stt = _.assign({}, params, portalState)

  action.get('uids', Map()).map((v, k) => {
    const keyPath = getKeyPathFromUID(k)
    const fullKeyPath = adjustKeyPathIfRepeat(keyPath, isBtnRepeat, index, retState)
    let value = _.get(stt, fullKeyPath, '')
    expression = expression.replace(new RegExp(`{${k}}`, 'g'), value)
  })
  return expression
}
